const MARKS_IN_TEXT = {
    PAGE_START: 'page_start',
    PAGE_END: 'page_end',
    ITALIC_START: 'stress_start',
    ITALIC_END: 'stress_end',
    TEXT: 'text',
    BREAK: 'break',
    PARAGRAPH_END: 'paragraph_end',
};
export const PROBE_DETAIL = 'probe-detail';
export default MARKS_IN_TEXT;
